import { useProductFilters } from "@nosto/search-js/preact/hooks"
import { SPECIAL_FILTER_FIELDS } from "@/components/FilterSidebar/SpecialFilters/SpecialFilters"
import styles from "./SelectedFilters.module.css"

/**
 * Active-filter chips shown above the grid: a label, one removable grey chip
 * per selected filter, and a "Clear All" link.
 */
export default function SelectedFilters() {
  const { filters, removeAll } = useProductFilters()

  if (filters.length === 0) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <span className={styles.label}>Active Filters:</span>
      {filters.map(filter => {
        if (!filter) {
          return null
        }
        // Special filters are on/off toggles, so show "Yes" rather than the
        // underlying facet value (e.g. "In Stock").
        const value = SPECIAL_FILTER_FIELDS.includes(filter.field) ? "Yes" : filter.value
        return (
          <button
            key={`${filter.name}: ${filter.value}`}
            className={styles.chip}
            onClick={e => {
              e.preventDefault()
              filter.remove()
            }}
            aria-label={`Remove filter ${filter.name}: ${value}`}
            type="button"
          >
            <span>
              {filter.name}: {value}
            </span>
            <span className={styles.remove} aria-hidden="true">
              ✕
            </span>
          </button>
        )
      })}
      <button className={styles.clearAll} onClick={removeAll} type="button">
        Clear All
      </button>
    </div>
  )
}
